import { useMessageActionContext } from '@/app/providers';
import { DropdownIcon } from '@/assets/images';
import { Dropdown } from '@/components';
import { useChatFeature } from '@/features/chats/chatsRegistry';
import { useMediaGroupActionDropdown } from '@/features/chats/viewmodels/useMediaGroupActionDropdown';
import PropTypes from 'prop-types';
import './MessageActionDropdown.scss';

const MediaGroupActionDropdown = ({ message, isSender, position = 'auto', activeChatJid }) => {
   const isMessageActionEnabled = useChatFeature('message-action');
   const { allowedActions } = useMessageActionContext();
   const { chatMenuItems: allItems } = useMediaGroupActionDropdown({ message, activeChatJid });

   const chatMenuItems = allowedActions?.length ? allItems.filter(item => allowedActions.includes(item.id)) : allItems;

   if (!isMessageActionEnabled || chatMenuItems.length === 0) return null;

   return (
      <div
         className={`message-quick-actions ${isSender ? 'sender-chat' : 'receiver-chat'} ${isMessageActionEnabled ? 'active' : 'inactive'} videoimagebubble`}
      >
         <Dropdown
            scrollContainerId="conversation-screen"
            icon={
               <i className="ct-flexCenter chevron-icon">
                  <DropdownIcon />
               </i>
            }
            items={chatMenuItems}
            withPadding={false}
            position={position || (isSender ? 'left' : 'right')}
            buttonClassName="ct-flexCenter dropdown-more-btn"
            dropdownClassName="message-action-dropdown-menu"
         />
      </div>
   );
};

MediaGroupActionDropdown.propTypes = {
   message: PropTypes.object.isRequired,
   isSender: PropTypes.bool,
   position: PropTypes.string,
   activeChatJid: PropTypes.string,
};

export default MediaGroupActionDropdown;
